

















































































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { dictServe, hiddenDangerLibraryServer, institutionServer, performanceServer, regionServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

import DetailView from '@/views/doublePrevention/hazardManagement/unit/detailView.vue';
import HazardManagementDetail from '@/views/doublePrevention/hazardManagement/unit/hazardManagementDetail.vue';
import ChooseDeptOfStaff from '@/views/inspectionContents/checklist/unit/choosePeople.vue';

import Axios from 'axios';
import publishObjectPath from '@/util/configRegistry';
const serverUrl = publishObjectPath.serverUrl;

@Component({
  components: { HazardManagementDetail, CollapseTransition, PagingUnit, DetailView, ChooseDeptOfStaff },
  mixins: [TableStripe],
})
export default class InspectionContents extends Vue {
  private editRoleFlag: any = 1; // 控制显示 列表 页面
  private row: any = {}; // 控制显示 详情 页面
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据

  // 表单数据对象
  formData: any = {
    areaId: '',
    hazardCategoryTagId: '',
    hazardLevel: '',
    search: '',
    // status: '',
    finishFlag: '',
    handleDepartmentId: '',
    initiateStaffId: '',
    initiateStaffName: '',
    startDate: '',
    endDate: '',
    source: '',
    initiateDepartmentId: '',
  };
  // table 数据对象
  tableData: any = [];

  // 隐患等级
  hazardLevelOptions: any = [];

  areaNameOptions: any = [];

  hazardCategoryTagNameOptions: any = [];

  statusOptions: any = [
    { value: false, label: '未完成' },
    { value: true, label: '已完成' },
  ];

  handleDepartmentOptions: any = []; // 整改部门数据
  hazardSourceList: any = []; // 隐患来源列表

  inputChange() {
    let arrStaff: any = [];
    if (this.formData.initiateStaffId) {
      arrStaff = [{ id: this.formData.initiateStaffId, name: this.formData.initiateStaffName }];
    } else {
      arrStaff = [];
    }
    (this.$refs['ChooseDeptOfStaffRef'] as any).showDialog(arrStaff, 'single');
  }
  getStaffData(data: any) {
    if (data && data.length) {
      this.formData.initiateStaffName = data[0].name;
      this.formData.initiateStaffId = data[0].id;
    } else {
      this.formData.initiateStaffName = '';
      this.formData.initiateStaffId = '';
    }
  }

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取分页数据
    this.getSecurityCheckHazardLevel();
    this.areaNameList();
    this.hazardCategoryTagNameList();
    // this.statusList();
    this.handleDepartmentIdList();
    this.getHazardSourceList();
  }
  getHazardSourceList() {
    hiddenDangerLibraryServer.getHazardSourceList({}).then((res: any) => {
      if (res.code === '200') {
        const arr: any = [];
        const obj: any = res.data;
        for (const key in obj) {
          arr.push({ value: key, label: obj[key] });
        }
        this.hazardSourceList = arr;
      }
    });
  }

  // 表格详情
  detailView(data: any) {
    this.row = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 3; // 进入表格详情页面
  }

  // 查看
  viewManagement(data: any) {
    this.row = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 2; // 进入编辑页面
  }

  getChangePost(data: any) {
    this.formData.hazardCategoryTagId = data.slice(-1).toString();
  }

  // 删除
  deleteManagement(id: any) {
    this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        hiddenDangerLibraryServer.deleteHazardManage(id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('成功删除了该条数据！');
            this.getPageData();
          } else {
            this.$message.warning(res.msg);
          }
        });
      })
      .catch(() => {
        this.$message.info('已取消删除');
      });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    const pageSearchData: any = {};
    for (const key in this.formData) {
      if ((this.formData as any)[key] && key !== 'initiateStaffName') {
        // 如果搜索表单里面的这一项有值，那么就加入到 分页搜索数据中
        (pageSearchData as any)[key] = (this.formData as any)[key];
      }
    }
    if (this.formData.finishFlag !== '') {
      pageSearchData.finishFlag = this.formData.finishFlag;
    }

    // 发起接口请求，获取分页数据
    hiddenDangerLibraryServer
      .getHazardManageList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        ...pageSearchData,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取隐患等级所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSecurityCheckHazardLevel() {
    // 发起接口请求，获取分页数据
    dictServe
      .getDetailsMapByName('securityCheckHazardLevel')
      .then((res: any) => {
        for (const key in res.data) {
          this.hazardLevelOptions.push({
            value: key,
            label: res.data[key],
          });
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  areaNameList() {
    const userInfo: any = JSON.parse((localStorage as any).getItem('userInfo'));
    // 发起接口请求，获取分页数据
    regionServe
      .getAreaAndSubAreaList({ areaId: userInfo.areaId })
      .then((res: any) => {
        if (res.code === '200') {
          this.areaNameOptions = arrayToTree(res.data);
          this.formData.areaId = userInfo.areaId;
          this.getPageData();
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  digui(data: any) {
    data.map((res: any, index: any) => {
      if (res.children && res.children.length > 0) {
        this.digui(res.children);
      } else {
        res.children = undefined;
      }
    });
    return data;
  }

  hazardCategoryTagNameList() {
    // 发起接口请求，获取分页数据
    performanceServer
      .getTagManageList({ type: 'hazardClassify' })
      .then((res: any) => {
        res.data.forEach((r: any) => {
          if (r.children && r.children.length > 0) {
            this.digui(r.children);
          } else {
            r.children = undefined;
          }
        });
        this.hazardCategoryTagNameOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  handleDepartmentIdList() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.handleDepartmentOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    (this.$refs.formRef as any).resetFields();
    this.formData.initiateStaffId = '';
    this.getPageData();
  }

  private handleMenuEditResponse() {
    this.editRoleFlag = 1;
    // this.getPageData();
  }
  exportDataTable() {
    const pageSearchData: any = {};
    for (const key in this.formData) {
      if ((this.formData as any)[key] && key !== 'initiateStaffName') {
        // 如果搜索表单里面的这一项有值，那么就加入到 分页搜索数据中
        (pageSearchData as any)[key] = (this.formData as any)[key];
      }
    }
    if (this.formData.finishFlag !== '') {
      pageSearchData.finishFlag = this.formData.finishFlag;
    }
    // 服务加载的动画
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    Axios({
      method: 'POST',
      url: serverUrl + '/api/yunnan/hazardManage/export/excel', // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
      data: {
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        ...pageSearchData,
      },
    })
      .then(response => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.$message({
          type: 'success',
          message: '导出成功!',
        });
      })
      .catch(error => {
        loading.close();
        this.$message({
          type: 'error',
          message: '导出失败,请联系管理员!',
        });
        console.log(error);
      });
  }
}
